// 转账人员类型
export enum transferType {
    New = "new",
    Old = "old",
}

// 是否有历史收款人
export enum payeeType {
    Has = 1,
    NoHas = 0,
}

// 接口请求状态
export enum requestStatusType {
    Success = 1,
    Fail = 0,
}

// 转账页面点击动作类型
export enum transferActionType {
    Input = 1,
    InputDelete = 2,
    PayeeManage = 3,
    PayeeManageDone = 4,
    PayeeDelete = 5,
    ToTransfer = 6,
    ClickPayee = 7,
}

// 转账页面状态类型
export enum transferPageStatusType {
    Search = 1,
    NoSearch = 0,
}

// 转账信息页收款人状态
export enum transferInformationPayeeStatusType {
    NoEdit = 0,
    Edit = 1,
}

// 转账信息页是否鞋带clabe状态
export enum transferInformationHasClabeType {
    NoHasClabe = 0,
    HasClabe = 1,
}

// 转账信息页点击动作类型
export enum transferInformationActionType {
    Clabe = 1,
    PayeeName = 2,
    BankName = 3,
    ExtraInfo = 4,
    Amount = 5,
    Remark = 6,
    Confirm = 7,
}

// 端内/外
export enum ClientStatus {
    inApp = '0',  // 端内
    webApp = '1'  // 端外
}